
/* injects from baggage-loader */

'use strict';

import HomeComponent from './home.component';
import './home.scss';

const HomePageModule = angular.module('home-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('home', {
        url: '/',
        component: 'home',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('home', new HomeComponent());

export default HomePageModule;



// WEBPACK FOOTER //
// ./src/app/pages/home/home.module.js